import React from 'react';
import PropTypes from 'prop-types';
import { getClassName } from '../../../utils/ui/classes';
function randstr(prefix) {
    return Math.random()
        .toString(36)
        .replace('0.', prefix || '');
}
const HalfFillGradient = ({ id }) => (React.createElement("defs", null,
    React.createElement("linearGradient", { id: id },
        React.createElement("stop", { offset: "50%", stopColor: "currentColor" }),
        React.createElement("stop", { offset: "50%", stopColor: "#ffffff" }))));
function getFillColor(fillType, id) {
    if (fillType === 'filled') {
        return 'currentColor';
    }
    if (fillType === 'half') {
        return `url(#${id})`;
    }
    return 'none';
}
function getStrokeColor(fillType) {
    if (fillType === 'filled') {
        return 'none';
    }
    return 'currentColor';
}
const StarIcon = ({ className, size, fillType }) => {
    const id = randstr('star');
    if (size === 'small') {
        return (React.createElement("svg", { className: getClassName(className), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: getFillColor(fillType, id), stroke: getStrokeColor(fillType) },
            React.createElement(HalfFillGradient, { id: id }),
            React.createElement("path", { d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" })));
    }
    return (React.createElement("svg", { className: getClassName(className), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: getFillColor(fillType, id), stroke: getStrokeColor(fillType) },
        React.createElement(HalfFillGradient, null),
        React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" })));
};
StarIcon.propTypes = {
    fillType: PropTypes.oneOf(['none', 'half', 'filled']),
    size: PropTypes.oneOf(['small', 'medium']),
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
};
StarIcon.defaultProps = {
    fillType: 'none',
    size: 'small',
    className: 'w-5 h-5',
};
export default StarIcon;
